import { ChevronDownIcon } from '@heroicons/react/24/outline'
import { useMediaQuery } from '@mantine/hooks'
import {
  projectOutputList,
  curriculumSimplelList,
  curriculumDetailList,
  supportSlideList,
  reviewSlideFirstList,
  reviewSlideSecondList,
  reviewSlideThirdList,
  benefitSlideList,
  bootCampFaqList,
  bootCampFaqTabList,
  ApplyScheduleList,
  EduScheduleList,
} from '../../../../constants/kdt-dataanalysis-5th'
import Aos from 'aos'
import dayjs from 'dayjs'
import Link from 'next/link'
import Image from 'next/image'
import ReactPlayer from 'react-player'
import { useState, useEffect, useMemo } from 'react'
import { useCopyUrlShare } from 'shared/hooks/useCopyUrlShare'
import CurriculumAccordion from './CurriculumAccordion'
import CurriculumTab from './CurriculumTab'
import {
  ProjectOutputSliderItem,
  CurriculumSimpleSliderItem,
  SupportSliderItem,
  ReviewSliderItem,
} from './SliderItem'
import styles from './kdt-dataanalysis-5th.module.scss'
import { schoolNavList, ScrollNav } from './ScrollNav'

const DataKlass5th = () => {
  const isMobile = useMediaQuery('(max-width: 1023px)')
  const [faqTab, setFaqTab] = useState('apply')
  const allFaqs = [
    ...bootCampFaqList.apply,
    ...bootCampFaqList.nebeka,
    ...bootCampFaqList.employment,
    ...bootCampFaqList.edu,
    ...bootCampFaqList.benefit,
    ...bootCampFaqList.etc,
  ]

  const faqList = faqTab === 'all' ? allFaqs : bootCampFaqList[faqTab]
  const onClickFaqTab = (value: string) => {
    setFaqTab(value)
  }

  useEffect(() => {
    Aos.init()
  }, [])

  const { copyUrlShare } = useCopyUrlShare()

  const earlySessionDate = new Date('2025-03-06 18:30')
  const isAfterEarlySessionDate = useMemo(() => dayjs().isAfter(earlySessionDate), [])
  const [activeTab, setActiveTab] = useState<
    'reviewFirstList' | 'reviewSecondList' | 'reviewThirdList'
  >('reviewFirstList')

  return (
    <div>
      {/* Section1_키비주얼 */}
      <section className="bg-gray-900">
        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="300"
          className={`${styles.section1_kv} relative w-full`}
        >
          <div className="absolute left-0 top-0 w-full">
            <Image
              src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section1_kv_after_load_ver2_${
                isMobile ? 'm' : 'pc'
              }.png`}
              layout="fill"
              objectFit="cover"
              className="!relative z-10 w-full object-cover"
              alt="-"
            />
          </div>
        </div>
      </section>

      {/* Section2_요약정보 */}
      <section className="bg-gray-900 pb-24 pt-6 lg:pb-[120px] lg:pt-8">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-6 px-4 lg:gap-8 lg:px-6">
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="flex w-full flex-col gap-3 lg:hidden lg:flex-row lg:gap-4"
          >
            <li className="flex flex-1 flex-row items-center justify-center gap-3 rounded-lg bg-[#1F1F1F] px-4 py-3 lg:gap-4 lg:px-6 lg:py-5">
              <img
                className="h-[72px] w-[72px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section2_img1.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-1 inline-block rounded bg-[rgba(255,119,16,0.10)] px-2 py-1 text-xs font-semibold text-yellow-450 lg:mb-2 lg:px-3 lg:font-bold">
                  POINT 1 - 데이터톤
                </p>
                <p className="text-sm leading-normal text-label-assistive lg:text-lg lg:font-semibold lg:text-white">
                  실제 데이터를 활용하는
                  <br />
                  데이터톤으로 쌓는 실전 경험
                </p>
              </div>
            </li>
            <li className="flex flex-1 flex-row items-center justify-center gap-3 rounded-lg bg-[#1F1F1F] px-4 py-3 lg:gap-4 lg:px-6 lg:py-5">
              <img
                className="h-[72px] w-[72px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section2_img3.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-1 inline-block rounded bg-[rgba(255,119,16,0.10)] px-2 py-1 text-xs font-semibold text-yellow-450 lg:mb-2 lg:px-3 lg:font-bold">
                  POINT 2 - 취업 지원
                </p>
                <p className="text-sm leading-normal text-label-assistive lg:text-lg lg:font-semibold lg:text-white">
                  인턴십과 채용 연계를 통한
                  <br />
                  현업 중심 실무 및 협업 경험
                </p>
              </div>
            </li>
            <li className="flex flex-1 flex-row items-center justify-center gap-3 rounded-lg bg-[#1F1F1F] px-4 py-3 lg:gap-4 lg:px-6 lg:py-5">
              <img
                className="h-[72px] w-[72px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section2_img2.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-1 inline-block rounded bg-[rgba(255,119,16,0.10)] px-2 py-1 text-xs font-semibold text-yellow-450 lg:mb-2 lg:px-3 lg:font-bold">
                  POINT 3 - 스터디 지원
                </p>
                <p className="text-sm leading-normal text-label-assistive lg:text-lg lg:font-semibold lg:text-white">
                  자격증(SQLD 등) 및
                  <br />
                  코딩테스트(알고리즘) 스터디 지원
                </p>
              </div>
            </li>
          </ul>

          <ul className="hidden w-full flex-col gap-3 lg:flex lg:flex-row lg:gap-4">
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-1 flex-row items-center justify-center gap-3 rounded-lg bg-[#1F1F1F] px-4 py-3 lg:gap-4 lg:px-6 lg:py-5"
            >
              <img
                className="h-[72px] w-[72px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section2_img1.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-1 inline-block rounded bg-[rgba(255,119,16,0.10)] px-2 py-1 text-xs font-semibold text-yellow-450 lg:mb-2 lg:px-3 lg:font-bold">
                  POINT 1 - 데이터톤
                </p>
                <p className="text-sm leading-normal text-label-assistive lg:text-lg lg:font-semibold lg:text-white">
                  실제 데이터를 활용하는
                  <br />
                  데이터톤으로 쌓는 실전 경험
                </p>
              </div>
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="800"
              className="flex flex-1 flex-row items-center justify-center gap-3 rounded-lg bg-[#1F1F1F] px-4 py-3 lg:gap-4 lg:px-6 lg:py-5"
            >
              <img
                className="h-[72px] w-[72px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section2_img3.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-1 inline-block rounded bg-[rgba(255,119,16,0.10)] px-2 py-1 text-xs font-semibold text-yellow-450 lg:mb-2 lg:px-3 lg:font-bold">
                  POINT 2 - 취업 지원
                </p>
                <p className="text-sm leading-normal text-label-assistive lg:text-lg lg:font-semibold lg:text-white">
                  인턴십과 채용 연계를 통한
                  <br />
                  현업 중심 실무 및 협업 경험
                </p>
              </div>
            </li>
            <li
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="1000"
              className="flex flex-1 flex-row items-center justify-center gap-3 rounded-lg bg-[#1F1F1F] px-4 py-3 lg:gap-4 lg:px-6 lg:py-5"
            >
              <img
                className="h-[72px] w-[72px] object-cover lg:h-[90px] lg:w-[90px]"
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section2_img2.png"
                alt="-"
              />
              <div className="flex flex-1 flex-col items-start justify-center">
                <p className="mb-1 inline-block rounded bg-[rgba(255,119,16,0.10)] px-2 py-1 text-xs font-semibold text-yellow-450 lg:mb-2 lg:px-3 lg:font-bold">
                  POINT 3 - 스터디 지원
                </p>
                <p className="text-sm leading-normal text-label-assistive lg:text-lg lg:font-semibold lg:text-white">
                  자격증(SQLD 등) 및<br />
                  코딩테스트(알고리즘) 스터디 지원
                </p>
              </div>
            </li>
          </ul>

          <hr className="hidden border-[#525252] lg:block" />

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-6 flex w-full flex-col lg:mt-0"
          >
            <li className="flex w-full flex-row items-start border-b border-[#3D3D3D] pb-3 lg:items-center lg:pb-4">
              <h6 className="flex w-[126px] flex-row items-center justify-start gap-3 text-sm font-semibold text-white lg:w-[calc(33.33%+16px)] lg:gap-4 lg:text-base">
                <img
                  className="h-5 w-5 lg:h-6 lg:w-6"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section2_icon1.png"
                  alt="-"
                />
                모집 기간
              </h6>
              <p className="text-sm text-label-assistive lg:w-2/3 lg:text-base">
                25.02.19 오후 2시 ~ <br className="block lg:hidden" />
                25.03.25 오후 11시
              </p>
            </li>
            <li className="flex w-full flex-row items-center border-b border-[#3D3D3D] py-3 lg:py-4">
              <h6 className="flex w-[126px] flex-row items-center justify-start gap-3 text-sm font-semibold text-white lg:w-[calc(33.33%+16px)] lg:gap-4 lg:text-base">
                <img
                  className="h-5 w-5 lg:h-6 lg:w-6"
                  src={
                    'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section2_icon2.png'
                  }
                  alt="-"
                />
                교육 기간
              </h6>
              <p className="text-sm text-label-assistive lg:w-2/3 lg:text-base">
                25.03.28 ~ 25.08.19
              </p>
            </li>
            <li className="flex w-full flex-row items-start pt-3 lg:pt-4">
              <h6 className="flex w-[126px] flex-row items-center justify-start gap-3 text-sm font-semibold text-white lg:w-[calc(33.33%+16px)] lg:gap-4 lg:text-base">
                <img
                  className="h-5 w-5 lg:h-6 lg:w-6"
                  src={
                    'https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-cld-3rd/section2_icon3.png'
                  }
                  alt="-"
                />
                교육 비용
              </h6>
              <p className="text-sm text-label-assistive lg:w-2/3 lg:text-base">
                <b>내일배움카드 소지 시 전액 무료</b> <br className="block lg:hidden" />
                <span className="hidden lg:inline-block">/</span>{' '}
                <span>*매월 최대 81만 원의 지원금 신청 가능</span>
              </p>
            </li>
          </ul>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="flex flex-col gap-3 overflow-hidden rounded-lg bg-[rgba(255,119,16,0.10)] px-4 py-3 lg:flex-row lg:gap-0 lg:px-10 lg:py-8"
          >
            <div className="w-full lg:w-[calc(33.33%+185px)]">
              <h5 className="text-sm font-bold text-yellow-450 lg:text-2xl">지원조건</h5>
            </div>
            <ul className={`${styles.section2_list_number} flex w-full flex-col gap-2`}>
              <li className="text-sm leading-normal text-white lg:text-base">
                국민내일배움카드 보유자 혹은 발급 가능하신 분
              </li>
              <li className="text-sm leading-normal text-white lg:text-base">
                평일 오전 9시부터 오후 6시까지 수업 참여가 가능하신 분
              </li>
              <li className="text-sm leading-normal text-white lg:text-base">
                직장 혹은 학교 등과 병행하지 않고 수업에만 집중 가능하신 분
              </li>
              <li className="text-sm leading-normal text-white lg:text-base">
                국내에 거주하고 계신 분
              </li>
            </ul>
          </div>
        </div>
      </section>

      <ScrollNav schoolNavList={schoolNavList} />

      {/* Section3_시장상황 */}
      <section className="bg-gray-900 pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-6 flex flex-col items-center justify-center gap-2 lg:mb-8 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">핵심 포인트</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-white lg:text-4xl lg:leading-tight">
              실제 데이터 분석 경험은
              <br />
              멋사 실무 프로젝트로 쌓으세요
            </h4>
            <p className="text-center text-sm leading-normal text-label-assistive lg:text-lg">
              단순히 Python과 SQL을 다룰 줄 아는 것만으로는 <br className="block lg:hidden" />
              부족합니다. <br className="hidden lg:block" />
              실제 데이터를 처리하고 분석하는 <br className="block lg:hidden" />
              실무 프로젝트 경험을 통해 ‘진짜 경험’을 쌓고,
              <br />
              기업이 원하는 인재로 거듭나 보세요!
            </p>
          </div>
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mx-auto max-w-[680px]"
          >
            <Image
              src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section3_img.png"
              layout="fill"
              objectFit="cover"
              className="!relative z-10 w-full object-cover"
              alt="-"
            />
          </div>
        </div>
      </section>

      {/* Section4_프로젝트 */}
      <section id="project" className="bg-[#FFF5EF] pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-12 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">프로젝트</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-label-normal lg:text-4xl">
              데이터 분석 실무 경험을 쌓는 <br className="block lg:hidden" />
              3단계 프로젝트
            </h4>
          </div>

          <div className="flex flex-col gap-8 lg:flex-row lg:items-stretch lg:gap-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-1 flex-col"
            >
              <div className="max-w-fit rounded-t bg-[#FFA662] px-3 py-1.5 shadow-[0_0_20px_0_rgba(255,119,16,0.25)] lg:py-2 lg:shadow-[0_0_40px_0_rgba(255,119,16,0.15)]">
                <p className="text-xs font-bold text-white lg:text-base">PROJECT 1</p>
              </div>
              <div className="relative z-[1] flex flex-col gap-4 rounded-lg rounded-tl-none bg-white px-4 pb-4 pt-3 shadow-[0_0_20px_0_rgba(255,119,16,0.25)] lg:gap-7 lg:px-8 lg:py-6 lg:shadow-[0_0_40px_0_rgba(255,119,16,0.15)]">
                <div className="flex flex-1 flex-col gap-0.5 lg:gap-2">
                  <h6 className="text-lg font-bold text-label-normal lg:text-2xl">
                    미드 프로젝트 - 대시보드 구축
                  </h6>
                  <p className="flex-1 text-sm leading-normal text-label-normal lg:min-h-12 lg:text-base">
                    기본적인 데이터 전처리와 분석을 통한 데이터 대시보드 구축
                  </p>
                </div>
                <Image
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_img1.gif"
                  layout="fill"
                  objectFit="cover"
                  className="!relative z-10 w-full object-cover"
                  alt="-"
                  unoptimized
                />
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-1 flex-col"
            >
              <div className="max-w-fit rounded-t bg-[#FF903C] px-3 py-1.5 shadow-[0_0_20px_0_rgba(255,119,16,0.25)] lg:py-2 lg:shadow-[0_0_40px_0_rgba(255,119,16,0.15)]">
                <p className="text-xs font-bold text-white lg:text-base">PROJECT 2</p>
              </div>
              <div className="relative z-[1] flex flex-col gap-4 rounded-lg rounded-tl-none bg-white px-4 pb-4 pt-3 shadow-[0_0_20px_0_rgba(255,119,16,0.25)] lg:gap-7 lg:px-8 lg:py-6 lg:shadow-[0_0_40px_0_rgba(255,119,16,0.15)]">
                <div className="flex flex-1 flex-col gap-0.5 lg:gap-2">
                  <h6 className="text-lg font-bold text-label-normal lg:text-2xl">
                    파이널 프로젝트 - 머신러닝/딥러닝
                  </h6>
                  <p className="flex-1 text-sm leading-normal text-label-normal lg:text-base">
                    머신러닝/딥러닝 기반 모델링을 추가한 데이터 대시보드를 구축하고 실시간 경쟁을
                    통해 모델 성능을 평가하고 리포트를 작성하는 데이터 분석 경연대회
                  </p>
                </div>
                <Image
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_img2.gif"
                  layout="fill"
                  objectFit="cover"
                  className="!relative z-10 w-full object-cover"
                  alt="-"
                  unoptimized
                />
              </div>
            </div>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-8 flex flex-1 flex-col lg:mt-6"
          >
            <div className="max-w-fit rounded-t bg-yellow-450 px-3 py-1.5 shadow-[0_0_20px_0_rgba(255,119,16,0.25)] lg:py-2 lg:shadow-[0_0_40px_0_rgba(255,119,16,0.15)]">
              <p className="text-xs font-bold text-white lg:text-base">PROJECT 3</p>
            </div>
            <div className="relative z-[1] flex flex-col rounded-lg rounded-tl-none bg-white px-4 pb-4 pt-3 shadow-[0_0_20px_0_rgba(255,119,16,0.25)] lg:px-8 lg:py-6 lg:shadow-[0_0_40px_0_rgba(255,119,16,0.15)]">
              <div className="mb-4 flex flex-1 flex-col gap-0.5 lg:mb-5 lg:gap-2">
                <h6 className="text-lg font-bold text-label-normal lg:text-2xl">데이터톤</h6>
                <p className="flex-1 text-sm leading-normal text-label-normal lg:text-base">
                  가설 설정부터 데이터 전처리, 모델 구축, 의사 결정까지 실무 데이터 분석의 전 과정을
                  모두 경험하고, <br className="hidden lg:block" />
                  대시보드 구축 및 보고서 작성을 통해 실무 경험을 강화하는 프로젝트
                </p>
              </div>
              <Image
                src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_img3_${
                  isMobile ? 'm' : 'pc'
                }.png`}
                layout="fill"
                objectFit="cover"
                className="!relative z-10 w-full object-cover"
                alt="-"
              />
              <div className="mt-10 flex flex-col gap-3 rounded bg-[#FCFAF9] p-4 lg:gap-2 lg:rounded-md lg:p-6">
                <h6 className="text-base font-bold text-label-normal lg:text-2xl">
                  데이터톤 핵심 포인트
                </h6>
                <ul className="flex flex-col gap-3 lg:flex-row lg:gap-6">
                  <li className="flex flex-col gap-0.5 border-b pb-3 lg:flex-1 lg:gap-2 lg:border-b-0 lg:border-r lg:pb-0 lg:pr-6 lg:pt-4">
                    <p className="text-sm font-bold text-label-normal lg:text-lg">
                      1. 원하는 산업군 선택
                    </p>
                    <p className="text-sm leading-normal text-label-normal lg:text-base">
                      내가 원하는 산업군에 맞는 프로젝트를 마음맞는 동료들과 함께 진행할 수 있어요
                    </p>
                  </li>
                  <li className="flex flex-col gap-0.5 border-b pb-3 lg:flex-1 lg:gap-2 lg:border-b-0 lg:border-r lg:pb-0 lg:pr-6">
                    <p className="text-sm font-bold text-label-normal lg:text-lg">
                      2. 커뮤니케이션 역량 강화
                    </p>
                    <p className="text-sm leading-normal text-label-normal lg:text-base">
                      오프라인 참여를 통해 팀원들과 교류하고 혼자서는 쌓기 힘든 협업 경험을 통해
                      커뮤니케이션 역량을 키워요
                    </p>
                    <p className="text-sm leading-normal text-label-neutral lg:-mt-1 lg:text-base">
                      *몰입감 있는 참여를 위해 온/오프라인 참여 중 선택 가능
                    </p>
                  </li>
                  <li className="flex flex-col gap-0.5 border-b pb-3 lg:flex-1 lg:gap-2 lg:border-b-0 lg:border-r lg:pb-0 lg:pr-6">
                    <p className="text-sm font-bold text-label-normal lg:text-lg">
                      3. 포트폴리오 강화
                    </p>
                    <p className="text-sm leading-normal text-label-normal lg:text-base">
                      데이터 분석의 전과정을 직접 경험하고, 실무에 필요한 경험을 쌓아 포트폴리오
                      경쟁력을 높여요
                    </p>
                  </li>
                  <li className="flex flex-col gap-0.5 lg:flex-1 lg:gap-2">
                    <p className="text-sm font-bold text-label-normal lg:text-lg">
                      4. 현직자 실시간 피드백
                    </p>
                    <p className="text-sm leading-normal text-label-normal lg:text-base">
                      프로젝트 결과물을 발표하고 실시간 피드백을 통해 개선점을 도출해요
                    </p>
                  </li>
                </ul>
              </div>
              <div className="mt-10 flex flex-col gap-4 rounded bg-[#FCFAF9] p-4 lg:gap-6 lg:rounded-md lg:p-10">
                <h6 className="text-base font-bold text-label-normal lg:text-2xl">
                  데이터톤 결과물
                </h6>
                <div className={`${styles.section4_slider}`}>
                  <ProjectOutputSliderItem contents={projectOutputList} />
                </div>
              </div>
              <div className="mt-10 flex flex-col gap-4 rounded bg-[#FCFAF9] p-4 lg:flex-row lg:justify-between lg:gap-6 lg:rounded-md lg:p-6">
                <h6 className="text-base font-bold text-label-normal lg:w-1/3 lg:text-2xl">
                  데이터톤 진행방식
                </h6>
                <ul className="flex flex-col gap-3 lg:max-w-[710px] lg:flex-1">
                  <li className="flex flex-row items-center gap-3 border-b pb-3 lg:flex-1">
                    <p className="shrink-0 rounded bg-[#FFE9D8] px-2 py-1 text-xs font-bold text-yellow-450 lg:px-2.5 lg:py-1.5 lg:text-sm">
                      STEP 1
                    </p>
                    <p className="text-sm leading-normal text-label-normal lg:text-lg">
                      수강생 팀빌딩 후, 공통의 실제 기업 <br className="block lg:hidden" />
                      데이터셋을 수강생에게 배포
                    </p>
                  </li>
                  <li className="flex flex-row items-center gap-3 border-b pb-3 lg:flex-1">
                    <p className="shrink-0 rounded bg-[#FFE9D8] px-2 py-1 text-xs font-bold text-yellow-450 lg:px-2.5 lg:py-1.5 lg:text-sm">
                      STEP 2
                    </p>
                    <p className="text-sm leading-normal text-label-normal lg:text-lg">
                      팀간 협업을 통해 서비스 개선점이나 <br className="block lg:hidden" />
                      문제해결 방안, 인사이트 추출
                    </p>
                  </li>
                  <li className="flex flex-row items-center gap-3 border-b pb-3 lg:flex-1">
                    <p className="shrink-0 rounded bg-[#FFE9D8] px-2 py-1 text-xs font-bold text-yellow-450 lg:px-2.5 lg:py-1.5 lg:text-sm">
                      STEP 3
                    </p>
                    <p className="text-sm leading-normal text-label-normal lg:text-lg">
                      팀별 발표자료, 시연영상, 인사이트 <br className="block lg:hidden" />
                      발표 진행 (종합 데이터 리포트 작성)
                    </p>
                  </li>
                  <li className="flex flex-row items-center gap-3 border-b pb-3 lg:flex-1">
                    <p className="shrink-0 rounded bg-[#FFE9D8] px-2 py-1 text-xs font-bold text-yellow-450 lg:px-2.5 lg:py-1.5 lg:text-sm">
                      STEP 4
                    </p>
                    <p className="text-sm leading-normal text-label-normal lg:text-lg">
                      현직 심사위원 참석 및 실시간 피드백 부여
                    </p>
                  </li>
                  <li className="flex flex-row items-center gap-3 border-b pb-3 lg:flex-1">
                    <p className="shrink-0 rounded bg-[#FFE9D8] px-2 py-1 text-xs font-bold text-yellow-450 lg:px-2.5 lg:py-1.5 lg:text-sm">
                      STEP 5
                    </p>
                    <p className="text-sm leading-normal text-label-normal lg:text-lg">
                      대상, 최우수상, 우수상 등 3개 팀에게 시상 및 현직자 추천서 제공
                    </p>
                  </li>
                  <li className="flex flex-row items-center gap-3 lg:flex-1">
                    <p className="shrink-0 rounded bg-[#FFE9D8] px-2 py-1 text-xs font-bold text-yellow-450 lg:px-2.5 lg:py-1.5 lg:text-sm">
                      STEP 6
                    </p>
                    <p className="text-sm leading-normal text-label-normal lg:text-lg">
                      수료식 및 종강
                    </p>
                  </li>
                </ul>
              </div>
              <div className="mt-10 flex flex-col gap-4 rounded bg-[#FCFAF9] p-4 lg:flex-row lg:justify-between lg:gap-6 lg:rounded-md lg:p-6">
                <h6 className="text-base font-bold text-label-normal lg:w-1/3 lg:text-2xl">
                  데이터톤 평가위원
                </h6>
                <div className="flex flex-col lg:max-w-[710px] lg:flex-1 lg:flex-row lg:gap-6">
                  <div className="mb-4 flex w-full shrink-0 flex-row items-center justify-start gap-4 border-b pb-4 lg:mb-0 lg:w-[266px] lg:border-0 lg:pb-0">
                    <div className="h-[78px] w-[76px] shrink-0 lg:h-[416px] lg:w-full">
                      <Image
                        src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section4_teacher_${
                          isMobile ? 'm' : 'pc'
                        }.png`}
                        layout="fill"
                        objectFit="cover"
                        className="!relative"
                        alt="-"
                      />
                    </div>
                    <dl className="flex flex-col lg:hidden">
                      <dt className="text-sm font-bold text-label-normal">박조은 멘토님</dt>
                      <dd className="text-xs leading-normal text-label-normal">
                        현직 데이터 분석 전문가가 직접 프로젝트를 평가하고 실무 피드백을 제공합니다
                      </dd>
                    </dl>
                  </div>
                  <div className="flex flex-col gap-3 lg:flex-1">
                    <dl className="hidden flex-col gap-2 lg:mb-6 lg:flex lg:border-b lg:pb-6">
                      <dt className="text-lg font-bold text-label-normal">박조은 멘토님</dt>
                      <dd className="text-base leading-normal text-label-normal">
                        현직 데이터 분석 전문가가 직접 프로젝트를 평가하고 실무 피드백을 제공합니다
                      </dd>
                    </dl>
                    <div className="flex flex-col gap-3">
                      <p className="max-w-fit rounded bg-[#FFE9D8] px-[16.5px] py-1 text-xs font-bold text-yellow-450 lg:px-2.5 lg:py-1.5 lg:text-sm">
                        약력
                      </p>
                      <div className="flex flex-col gap-0.5 border-b pb-3 lg:gap-1">
                        <p
                          className={`${styles.text_dot} ${styles.text_dot_section_teacher} text-sm leading-normal text-label-neutral lg:text-base`}
                        >
                          (現) 오늘코드 대표
                        </p>
                        <p
                          className={`${styles.text_dot} ${styles.text_dot_section_teacher} text-sm leading-normal text-label-neutral lg:text-base`}
                        >
                          (前) 네오위즈게임즈 백엔드 개발자
                        </p>
                        <p
                          className={`${styles.text_dot} ${styles.text_dot_section_teacher} text-sm leading-normal text-label-neutral lg:text-base`}
                        >
                          (前) 모두의 한국어 텍스트 분석 with 파이썬 출판
                        </p>
                        <p
                          className={`${styles.text_dot} ${styles.text_dot_section_teacher} text-sm leading-normal text-label-neutral lg:text-base`}
                        >
                          (前) 멋쟁이사자처럼 AI 부트캠프 강사
                        </p>
                      </div>
                      <div className="flex flex-col gap-0.5 lg:gap-1">
                        <p
                          className={`${styles.text_dot} ${styles.text_dot_section_teacher} text-sm leading-normal text-label-neutral lg:text-base`}
                        >
                          프로젝트 기획 및 데이터 분석 과정 피드백
                        </p>
                        <p
                          className={`${styles.text_dot} ${styles.text_dot_section_teacher} text-sm leading-normal text-label-neutral lg:text-base`}
                        >
                          비즈니스 관점에서의 데이터 활용성 평가
                        </p>
                        <p
                          className={`${styles.text_dot} ${styles.text_dot_section_teacher} text-sm leading-normal text-label-neutral lg:text-base`}
                        >
                          기술적 심사 및 프로젝트 발표 평가
                        </p>
                        <p
                          className={`${styles.text_dot} ${styles.text_dot_section_teacher} text-sm leading-normal text-label-neutral lg:text-base`}
                        >
                          우수 프로젝트 심사 및 추천서 작성
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section5_커리큘럼 */}
      <section id="curriculum" className="bg-gray-900 pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-20 flex flex-col items-center justify-center gap-2 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">커리큘럼</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-white lg:text-4xl lg:leading-tight">
              데이터 분석의 기초부터 <br className="block lg:hidden" />
              실무 적용까지,
              <br />
              단계별 성장 커리큘럼
            </h4>
            <p className="text-center text-sm leading-normal text-label-assistive lg:text-lg">
              비전공자도 이해할 수 있도록 기초부터 <br className="block lg:hidden" />
              체계적으로 설계된 커리큘럼으로, <br className="hidden lg:block" />
              실무에서 바로 <br className="block lg:hidden" />
              적용할 수 있는 데이터 분석 역량까지 키워 <br className="block lg:hidden" />
              다양한 산업군의 <br className="hidden lg:block" />
              데이터 분석 직무로 취업할 수 있어요
            </p>
          </div>

          <h6
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mb-6 text-center text-lg font-bold text-yellow-450 lg:text-2xl"
          >
            커리큘럼 한눈에 보기
          </h6>

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mb-20 hidden flex-row flex-wrap gap-4 lg:flex"
          >
            {curriculumSimplelList.map(simple => (
              <li
                className="flex h-[207px] w-[calc(20%-12.8px)] flex-col gap-4 rounded-lg bg-trueGray-800 p-6"
                key={simple.title}
              >
                <img className="h-12 w-12 object-cover" src={simple.imgUrl} alt={simple.title} />
                <div className="flex flex-col gap-0.5">
                  <h6 className="text-base font-bold text-white">{simple.title}</h6>
                  <p className="whitespace-pre-line text-base leading-normal text-label-assistive">
                    {simple.desc}
                  </p>
                </div>
              </li>
            ))}
          </ul>
        </div>

        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="600"
          className="mb-20 lg:hidden"
        >
          <CurriculumSimpleSliderItem contents={curriculumSimplelList} />
        </div>

        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <h6
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mb-6 text-center text-lg font-bold text-yellow-450 lg:text-2xl"
          >
            커리큘럼 자세히 보기
          </h6>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} hidden flex-row overflow-hidden rounded-lg bg-trueGray-800 lg:flex`}
          >
            <CurriculumTab curriculumDetailList={curriculumDetailList} />
          </div>

          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.curriculum_accordion_wrap} flex flex-col overflow-hidden lg:hidden`}
          >
            {curriculumDetailList.map((curriculum, idx) => (
              <CurriculumAccordion contents={curriculum} key={curriculum.title} idx={idx} />
            ))}
          </ul>
        </div>
      </section>

      {/* Section6_수료후직무 */}
      <section className="bg-trueGray-800 pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-7 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">수료 후 직무</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-white lg:text-4xl lg:leading-tight">
              꿈꾸던 데이터 분석 <br className="block lg:hidden" />
              직무로의 도약
            </h4>
            <p className="text-center text-sm leading-normal text-label-assistive lg:text-lg">
              멋쟁이사자처럼 데이터 분석 부트캠프의
              <br />
              5개월 과정을 수료하면 이런 직무를 선택할 수 있어요
            </p>
          </div>

          <div className="flex flex-col gap-3 lg:flex-row lg:items-stretch lg:gap-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex w-full flex-1 flex-col gap-3 overflow-hidden rounded-lg bg-white p-4 lg:w-auto lg:p-6"
            >
              <div className="flex flex-row gap-2 lg:gap-3">
                <span className="flex h-[22px] w-[22px] items-center justify-center rounded bg-[#FFE9D8] text-xs font-bold text-yellow-450 lg:h-7 lg:w-7 lg:text-base">
                  1
                </span>
                <p className="text-base font-bold text-label-normal lg:text-xl">
                  데이터 분석가(Data Analyst)
                </p>
              </div>
              <ul className="flex flex-col gap-2 lg:gap-3">
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section6} border-b pb-2 text-sm text-label-normal lg:pb-3 lg:text-base`}
                >
                  데이터 기반 의사 결정을 위해 데이터를 분석/시각화 하는 직무
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section6} text-sm text-label-normal lg:text-base`}
                >
                  필요 스킬 : Python/SQL, 통계 이해도, 시각화 역량, 도메인 지식
                </li>
              </ul>
            </div>

            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="800"
              className="flex w-full flex-1 flex-col gap-3 overflow-hidden rounded-lg bg-white p-4 lg:w-auto lg:p-6"
            >
              <div className="flex flex-row gap-2 lg:gap-3">
                <span className="flex h-[22px] w-[22px] items-center justify-center rounded bg-[#FFE9D8] text-xs font-bold text-yellow-450 lg:h-7 lg:w-7 lg:text-base">
                  2
                </span>
                <p className="text-base font-bold text-label-normal lg:text-xl">
                  비즈니스 분석가(Business Analyst)
                </p>
              </div>
              <ul className="flex flex-col gap-2 lg:gap-3">
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section6} border-b pb-2 text-sm text-label-normal lg:pb-3 lg:text-base`}
                >
                  비즈니스 데이터를 분석해 의미를 찾는 업무
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section6} text-sm text-label-normal lg:text-base`}
                >
                  필요 스킬 : SQL, 데이터 시각화 역량(Tableau 등), 커뮤니케이션 역량
                </li>
              </ul>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="1000"
              className="flex w-full flex-1 flex-col gap-3 overflow-hidden rounded-lg bg-white p-4 lg:w-auto lg:p-6"
            >
              <div className="flex flex-row gap-2 lg:gap-3">
                <span className="flex h-[22px] w-[22px] items-center justify-center rounded bg-[#FFE9D8] text-xs font-bold text-yellow-450 lg:h-7 lg:w-7 lg:text-base">
                  3
                </span>
                <p className="text-base font-bold text-label-normal lg:text-xl">
                  그로스 마케터(Growth Marketer)
                </p>
              </div>
              <ul className="flex flex-col gap-2 lg:gap-3">
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section6} border-b pb-2 text-sm text-label-normal lg:pb-3 lg:text-base`}
                >
                  제품 지표 성장을 위해 필요한 데이터 기반 광고 최적화, 고객 관계 관리(CRM)를
                  수행하는 마케터
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section6} text-sm text-label-normal lg:text-base`}
                >
                  필요 스킬 : SQL, Google Analytics, 통계 이해도
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Section8_커리큘럼상세 */}
      <section id="support" className="bg-gray-900 pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-7 flex flex-col items-center justify-center gap-2 px-4 lg:mb-16 lg:gap-4 lg:px-0"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">취업 지원</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-white lg:text-4xl lg:leading-tight">
              총 1억 5천만원 상당의
              <br />
              취업을 위한 핵심 지원
            </h4>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.section8_slider} lg:hidden`}
          >
            <SupportSliderItem details={supportSlideList} />
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`hidden flex-col flex-wrap gap-3 lg:flex lg:flex-row lg:flex-wrap lg:gap-6`}
          >
            {supportSlideList.map(({ step, desc, title, imgUrlPc, imgUrlM, contents }) => (
              <div
                className="flex h-[366px] w-[calc(33.33%-16px)] flex-col overflow-hidden rounded-lg bg-trueGray-800 lg:h-[474px]"
                key={title}
              >
                <div className="w-full overflow-hidden">
                  <Image
                    src={isMobile ? imgUrlM : imgUrlPc}
                    layout="fill"
                    objectFit="cover"
                    className="!relative"
                    alt={title}
                  />
                </div>
                <div className="flex flex-col p-4 lg:p-6">
                  <p className="mb-1 max-w-fit rounded-sm bg-[rgba(255,119,16,0.1)] px-2 py-0.5 text-xs font-bold text-yellow-450 lg:mb-2 lg:rounded lg:text-base">
                    {step}
                  </p>
                  <h6 className="mb-2 text-lg font-bold leading-normal text-white lg:mb-3 lg:text-2xl">
                    {title}
                  </h6>
                  {desc && (
                    <p className="text-sm leading-normal text-label-assistive lg:text-base lg:text-white">
                      {desc}
                    </p>
                  )}
                  {contents && contents.length > 0 && (
                    <>
                      {contents.map(({ contentsId, contentsInner, contentsCaution }) => (
                        <div key={contentsId}>
                          {contentsInner && (
                            <ul className="flex w-full flex-col">
                              {contentsInner.map(inner => (
                                <li
                                  key={inner}
                                  className="border-b border-[#404040] py-2 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0 lg:py-3"
                                >
                                  <p className="text-sm leading-normal text-label-assistive lg:text-base lg:text-white">
                                    {inner}
                                  </p>
                                </li>
                              ))}
                            </ul>
                          )}
                          {contentsCaution && (
                            <p className="mt-2 border-t border-[#404040] pt-1 text-sm text-label-assistive lg:mt-3 lg:pt-3 lg:text-base">
                              {contentsCaution}
                            </p>
                          )}
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Section7_스터디지원 */}
      <section className="bg-trueGray-800 pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-7 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">스터디 지원</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-white lg:text-4xl lg:leading-tight">
              마음 맞는 동료와 <br className="hidden lg:block" />
              함께하는 <br className="block lg:hidden" />
              데이터 분석가 취업 스터디
            </h4>
            <p className="text-center text-sm leading-normal text-label-assistive lg:text-lg">
              지원자에 한해 데이터 분석 자격증과
              <br />
              코딩테스트 스터디 운영을 지원하고 취업 성공까지 <br className="block lg:hidden" />
              아낌없는 도움을 드려요
            </p>
          </div>

          <div className="flex flex-col gap-3 lg:flex-row lg:gap-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex w-full flex-1 flex-col gap-3 overflow-hidden rounded-lg bg-gray-900 p-4 lg:w-auto lg:p-6"
            >
              <div className="flex flex-row gap-3 border-b border-[#404040] pb-3 lg:gap-4">
                <p className="text-base font-bold text-yellow-450 lg:text-2xl">자격증 준비반</p>
                <span className="rounded bg-[rgba(255,119,16,0.12)] px-2 py-1 text-xs font-semibold text-yellow-450 lg:text-sm">
                  응시료 전액 환급 혜택!
                </span>
              </div>
              <p className="text-sm leading-normal text-white lg:min-h-12 lg:text-base">
                데이터 분석 자격증(SQLD·ADsP·빅데이터분석기사) 취득에{' '}
                <br className="block lg:hidden" />
                도움을 받을 수 있는 스터디를 지원해요
              </p>
              <div className="w-full overflow-hidden rounded">
                <Image
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section7_img1.gif"
                  layout="fill"
                  objectFit="cover"
                  className="!relative h-full w-full"
                  alt="-"
                  unoptimized
                />
              </div>
              <ul className="flex flex-col lg:gap-0.5">
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section7} text-sm leading-normal text-label-assistive lg:text-base`}
                >
                  자격증 자료 제공
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section7} text-sm leading-normal text-label-assistive lg:text-base`}
                >
                  사이트 추천
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section7} text-sm leading-normal text-label-assistive lg:text-base`}
                >
                  응시료 전액 환급
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section7} text-sm leading-normal text-label-assistive lg:text-base`}
                >
                  자격증 도서 제공
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section7} text-sm leading-normal text-label-assistive lg:text-base`}
                >
                  데일리 스터디 인증
                </li>
              </ul>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="800"
              className="flex w-full flex-1 flex-col gap-3 overflow-hidden rounded-lg bg-gray-900 p-4 lg:w-auto lg:p-6"
            >
              <div className="flex flex-row gap-3 border-b border-[#404040] pb-3 lg:gap-4">
                <p className="text-base font-bold text-yellow-450 lg:text-2xl">코딩테스트 준비반</p>
              </div>
              <p className="text-sm leading-normal text-white lg:min-h-12 lg:text-base">
                중견기업·대기업 취준에 필수인 코딩테스트를 준비할 수 있는 스터디를 지원해요
              </p>
              <div className="w-full overflow-hidden rounded">
                <Image
                  src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section7_img2_${
                    isMobile ? 'm' : 'pc'
                  }.png`}
                  layout="fill"
                  objectFit="cover"
                  className="!relative h-full w-full"
                  alt="-"
                />
              </div>
              <ul className="flex flex-col lg:gap-0.5">
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section7} text-sm leading-normal text-label-assistive lg:text-base`}
                >
                  멋쟁이사자처럼 파이썬 코딩테스트 VOD 강의 제공
                </li>
                <li
                  className={`${styles.text_dot} ${styles.text_dot_section7} text-sm leading-normal text-label-assistive lg:text-base`}
                >
                  난이도별 준비 가이드 제공
                </li>

                <li
                  className={`${styles.text_dot} ${styles.text_dot_section7} text-sm leading-normal text-label-assistive lg:text-base`}
                >
                  주차별 알고리즘 과제 부여
                </li>
              </ul>
            </div>
          </div>
        </div>
      </section>

      {/* Section9_강사진 */}
      <section id="teacher" className="bg-gray-900 pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">강사진</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-white lg:text-4xl">
              반복 설명을 통해 <br className="block lg:hidden" />
              이해가 될 때까지! <br className="hidden lg:block" />
              데이터 분석 <br className="block lg:hidden" />
              기초부터 차근차근 알려드려요
            </h4>
          </div>
          <div className="flex w-full flex-col gap-4 lg:flex-row lg:gap-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex w-full flex-col rounded-lg bg-trueGray-800 p-4 lg:w-auto lg:flex-1 lg:flex-row lg:flex-wrap lg:p-6"
            >
              <div className="flex flex-row items-center gap-4 border-b border-[#404040] pb-4 lg:w-[266px] lg:border-0 lg:pb-0">
                <img
                  className="h-[72px] w-[70px] object-cover lg:h-auto lg:w-[266px]"
                  src={`https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section9_img1_${
                    isMobile ? 'm' : 'pc'
                  }.png`}
                  alt="윤재성 강사님 이미지"
                />
                <div className="flex flex-col items-start justify-start lg:hidden">
                  <p className="text-xs font-bold text-yellow-450">교육 주강사</p>
                  <h6 className="text-base font-bold text-white">윤재성 강사님</h6>
                </div>
              </div>

              <dl className="flex w-full flex-col gap-4 lg:ml-6 lg:w-auto lg:flex-1 lg:gap-7">
                <div role="group" className="hidden flex-col gap-2 lg:flex">
                  <dt className="text-base font-bold text-yellow-450">교육 주강사</dt>
                  <dd className="text-3xl font-bold leading-normal text-white">윤재성 강사님</dd>
                </div>
                <div
                  role="group"
                  className="flex flex-col gap-0.5 pt-4 lg:gap-1 lg:border-t lg:border-[#404040] lg:pt-7"
                >
                  <dt className="text-sm font-bold text-white lg:text-base">경력사항</dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section9} text-sm leading-normal text-label-assistive lg:text-base`}
                  >
                    현) 소프트캠퍼스 대표 이사
                  </dd>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section9} text-sm leading-normal text-label-assistive lg:text-base`}
                  >
                    전) S사 K사 L사 등 대기업 주요 프로젝트 론칭
                  </dd>
                </div>
                <div
                  role="group"
                  className="flex flex-col gap-0.5 border-t border-[#404040] pt-4 lg:gap-1 lg:pt-7"
                >
                  <dt className="text-sm font-bold text-white lg:text-base">이력</dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section9} text-sm leading-normal text-label-assistive lg:text-base`}
                  >
                    20년 경력 현업 IT 전문가
                  </dd>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section9} text-sm leading-normal text-label-assistive lg:text-base`}
                  >
                    삼성전자, LG전자, SK C&C, 한화 C&C 및 국내 유수 교육기관 실무 강의 경력
                  </dd>
                </div>
              </dl>

              <div className="mt-4 flex w-full flex-col gap-1 rounded bg-gray-900 p-4">
                <h6 className="text-sm font-bold text-white lg:text-base">강사님 한마디</h6>
                <p className="text-sm leading-normal text-white lg:min-h-[72px] lg:text-base">
                  지금 이 순간에도 무수히 많은 데이터들이 발생하고 있습니다. 그리고 이 데이터를
                  해석하면 미래를 예견할 수 있습니다. 멋쟁이사자처럼과 함께 미래를 예견하는 능력을
                  키워나가 보아요.
                </p>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="800"
              className="flex w-full flex-col rounded-lg bg-trueGray-800 p-4 lg:w-auto lg:max-w-[414px] lg:flex-1 lg:p-6"
            >
              <div className="flex flex-row items-center gap-4 border-b border-[#404040] pb-4 lg:pb-6">
                <img
                  className="h-[72px] w-[70px] object-cover lg:h-[120px] lg:w-[120px]"
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section9_img2.png"
                  alt="-"
                />
                <div className="flex flex-1 flex-col items-start justify-start lg:gap-0.5">
                  <p className="text-xs font-bold text-yellow-450 lg:text-sm">멘토</p>
                  <h6 className="text-base font-bold text-white lg:text-2xl">스페셜 멘토님</h6>
                </div>
              </div>

              <dl className="flex w-full flex-col gap-4 lg:w-auto lg:flex-1 lg:gap-6">
                <div role="group" className="flex flex-col gap-0.5 pt-4 lg:gap-1 lg:pt-6">
                  <dt className="text-sm font-bold text-white lg:text-base">멘토링 항목</dt>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section9} text-sm leading-normal text-label-assistive lg:text-base`}
                  >
                    자유주제 질의응답
                  </dd>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section9} text-sm leading-normal text-label-assistive lg:text-base`}
                  >
                    이력서/포트폴리오 피드백
                  </dd>
                  <dd
                    className={`${styles.text_dot} ${styles.text_dot_section9} text-sm leading-normal text-label-assistive lg:text-base`}
                  >
                    프로젝트 피드백
                  </dd>
                </div>
              </dl>

              <div className="mt-4 flex w-full flex-col gap-1 rounded bg-gray-900 p-4">
                <h6 className="text-sm font-bold text-white lg:text-base">멘토링 포인트</h6>
                <p className="text-sm leading-normal text-white lg:text-base">
                  현업에 종사하고 있는 현직 데이터 분석가 멘토진의 밀착 케어로 모르는 부분은 언제든
                  질문을 통해 해결하고, 실제 현업에서의 노하우까지 전수받을 수 있어요.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Section10_사전설명회 */}
      <section className="bg-[#FFF3EB] pb-24 pt-20 lg:pb-40 lg:pt-36">
        {isAfterEarlySessionDate ? (
          <div className="mx-auto flex w-full max-w-7xl flex-col items-center justify-center px-4 lg:px-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="mb-10 flex w-full flex-col gap-2 lg:mb-16 lg:gap-4"
            >
              <h4 className="text-center text-2xl font-bold leading-snug text-label-normal lg:text-4xl">
                고민상담소 다시보기
              </h4>
              <p className="text-center text-sm text-label-normal lg:text-base">
                실시간 라이브로 진행된 고민상담소 다시보기
              </p>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="w-full"
              style={{
                position: 'relative',
                paddingTop: '56.25%',
              }}
            >
              <ReactPlayer
                alt="멋쟁이사자처럼 사전설명회 Live"
                url="https://youtube.com/live/gCN4X1A3dkU"
                controls={true}
                width="100%"
                height="100%"
                style={{
                  position: 'absolute',
                  top: 0,
                  left: 0,
                  width: '100%',
                  height: '100%',
                }}
              />
            </div>
          </div>
        ) : (
          <div className="mx-auto w-full max-w-7xl px-4 lg:flex lg:flex-row lg:items-center lg:justify-between lg:gap-16 lg:px-6">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="flex flex-col"
            >
              <div className="flex flex-col items-center justify-center lg:w-[535px] lg:shrink-0 lg:items-start">
                <p className="mb-2 text-sm font-bold text-yellow-450 lg:mb-2.5 lg:text-lg">
                  고민상담소 안내
                </p>
                <h4 className="mb-8 text-center text-2xl font-bold leading-tight text-label-normal lg:mb-4 lg:text-left lg:text-4xl">
                  데이터 분석 <br className="block lg:hidden" />
                  무엇이든 물어보세요!
                </h4>
                <div className="mb-4 w-full overflow-hidden rounded-lg lg:hidden">
                  <Image
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section10_img.gif"
                    layout="fill"
                    objectFit="cover"
                    className="!relative z-10 w-full object-cover"
                    alt="*참고용 사전설명회 진행 모습"
                    unoptimized
                  />
                </div>
                <p className="mb-2 text-center text-sm leading-normal text-label-normal lg:text-left lg:text-base">
                  교육 시작 전, 강사님께 직접 물어보는
                  <br />
                  데이터 분석 및 부트캠프에 대한 모든 것!
                  <br />
                  실시간으로 진행되는 고민상담소에서 <br className="block lg:hidden" />
                  궁금한 점들을 모두 해결해 보세요.
                </p>
                <p className="text-center text-sm font-bold leading-normal text-yellow-450 lg:text-left lg:text-base">
                  일정 : 3월 6일(목) 오후 6시 30분
                  <br />
                  장소 : Youtube 라이브 스트리밍
                </p>
              </div>
              <div className="mt-10 flex w-full flex-col lg:mt-12">
                <Link
                  href="https://likelion2.typeform.com/kdtdab05pre"
                  target="_blank"
                  className="flex w-full items-center justify-center gap-2 rounded-lg bg-yellow-450 py-4 text-sm font-bold text-label-normal lg:max-w-[395px] lg:gap-2.5 lg:py-5 lg:text-lg"
                >
                  고민상담소 신청하기
                  <img
                    className="h-4 w-4 lg:h-5 lg:w-5"
                    src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/pre-orientation_icon.png"
                    alt="사전설명회"
                  />
                </Link>
              </div>
            </div>
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="max-w-1/2 hidden h-[341px] overflow-hidden rounded lg:inline-block"
            >
              <Image
                src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-dataanalysis-5th/section10_img.gif"
                layout="fill"
                objectFit="cover"
                className="!relative z-10 w-full object-cover"
                alt="*참고용 사전설명회 진행 모습"
                unoptimized
              />
            </div>
          </div>
        )}
      </section>

      {/* Section11_수강후기 */}
      <section className="bg-gray-900 pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-6 flex flex-col items-center justify-center gap-2 px-4 lg:mb-16 lg:gap-4 lg:px-0"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">수강 후기</p>
            <h4 className="text-center text-2xl font-bold leading-snug text-white lg:text-4xl lg:leading-tight">
              앞서 졸업한 수료생들의
              <br />
              생생한 후기
            </h4>
            <p className="text-sm text-label-assistive lg:text-lg">
              수강 후기는 수료생이 직접 작성한 내용입니다
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="flex w-full flex-col gap-12 lg:flex-row"
          >
            <div className="flex shrink-0 flex-row items-center justify-center gap-1.5 lg:flex-col lg:items-start lg:justify-start lg:gap-4">
              {[
                { key: 'reviewFirstList', label: '프로젝트' },
                { key: 'reviewSecondList', label: '커리큘럼' },
                { key: 'reviewThirdList', label: '강사/멘토/운영진' },
              ].map(({ key, label }) => (
                <button
                  key={key}
                  onClick={() =>
                    setActiveTab(key as 'reviewFirstList' | 'reviewSecondList' | 'reviewThirdList')
                  }
                  className={`max-w-fit rounded-full border px-5 py-1.5 text-xs transition-all lg:text-lg ${
                    activeTab === key
                      ? 'border-yellow-450 bg-yellow-450 font-bold text-white'
                      : 'border-label-neutral bg-trueGray-800 font-normal text-label-assistive'
                  }`}
                >
                  {label}
                </button>
              ))}
            </div>

            <div className="w-full lg:w-[calc(100%-211px)] lg:max-w-[1023px]">
              {activeTab === 'reviewFirstList' && (
                <div className={`${styles.section11_slider}`}>
                  <ReviewSliderItem reviews={reviewSlideFirstList} />
                </div>
              )}
              {activeTab === 'reviewSecondList' && (
                <div className={`${styles.section11_slider}`}>
                  <ReviewSliderItem reviews={reviewSlideSecondList} />
                </div>
              )}
              {activeTab === 'reviewThirdList' && (
                <div className={`${styles.section11_slider}`}>
                  <ReviewSliderItem reviews={reviewSlideThirdList} />
                </div>
              )}
            </div>
          </div>
        </div>
      </section>

      {/* Section12_추가교육혜택 */}
      <section className="bg-trueGray-800 pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mb-10 flex flex-col items-center justify-center gap-2 lg:mb-16 lg:gap-4"
          >
            <p className="text-sm font-bold text-yellow-450 lg:text-lg">추가 교육 혜택</p>
            <h4 className="text-center text-xl font-bold leading-snug text-white lg:text-left lg:text-4xl lg:leading-[1.4]">
              오직 열정만 준비하세요
            </h4>
            <p className="text-center text-xs leading-normal text-label-assistive lg:text-left lg:text-lg">
              나머지는 멋쟁이사자처럼에서 모두 지원해 드릴게요
            </p>
          </div>

          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className={`${styles.section16_mediaquery} flex flex-col flex-wrap gap-3 lg:flex-row lg:gap-6`}
          >
            {benefitSlideList.map(({ desc, title, imgUrlPc, imgUrlM, caution }) => (
              <div
                className="flex flex-col justify-between gap-3 rounded-lg bg-gray-900 px-6 py-4 lg:h-[304px] lg:w-[calc(25%-18px)] lg:gap-0 lg:py-5"
                key={title}
              >
                <div className="flex flex-col gap-1">
                  <h6 className="text-base font-bold text-white lg:text-lg">{title}</h6>
                  <p className="whitespace-pre-wrap text-sm leading-normal text-label-assistive lg:text-base">
                    {desc}
                  </p>
                  {caution && (
                    <p className="whitespace-pre-wrap text-left text-sm leading-normal text-label-neutral">
                      {caution}
                    </p>
                  )}
                </div>
                <div className="flex flex-row items-end justify-end">
                  <img
                    src={isMobile ? imgUrlM : imgUrlPc}
                    className="block h-[90px] w-auto object-contain"
                    loading="lazy"
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* section13_지원및선발일정 */}
      <section id="condition" className="bg-[#FFF9F5] pb-24 pt-20 lg:pb-40 lg:pt-36">
        <div className="mx-auto flex w-full max-w-7xl flex-col gap-20 px-4 lg:mx-auto lg:flex-row lg:gap-6 lg:px-6">
          <div className="w-full lg:w-auto lg:flex-1">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="mb-6 lg:mb-8"
            >
              <h4 className="text-center text-xl font-bold text-label-normal lg:text-left lg:text-3xl">
                지원 및 선발 안내
              </h4>
            </div>

            <ul
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="flex flex-col rounded-lg bg-white p-4 lg:min-h-[260px] lg:gap-0 lg:px-6 lg:py-5"
            >
              {ApplyScheduleList.map(edu => (
                <li
                  className="flex flex-row items-start justify-start gap-5 border-b py-2 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0 lg:gap-6"
                  key={edu.title}
                >
                  <h6 className="w-[51px] whitespace-pre-line text-sm font-semibold leading-normal text-yellow-450 lg:w-[80px] lg:shrink-0 lg:text-base lg:font-bold">
                    {edu.title}
                  </h6>
                  <div className="flex-1 lg:w-auto">
                    {edu.content ? (
                      <p className="whitespace-pre-line text-sm text-label-normal lg:whitespace-normal lg:text-base">
                        {edu.content}
                      </p>
                    ) : (
                      <ul className="-my-2 flex w-full flex-col lg:-my-1.5 lg:flex-1">
                        {edu.contents?.map(item => (
                          <li
                            key={`${edu.title}-${item}`}
                            className={`${styles.text_dot} ${styles.text_dot_section13} whitespace-pre-line border-b py-2 text-sm text-label-normal last-of-type:border-0 lg:whitespace-normal lg:py-1.5 lg:text-base`}
                          >
                            {item}
                          </li>
                        ))}
                      </ul>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          </div>

          <div className="w-full lg:w-auto lg:flex-1">
            <div
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="300"
              className="mb-6 lg:mb-8"
            >
              <h4 className="text-center text-xl font-bold text-label-normal lg:text-left lg:text-3xl">
                교육 일정 안내
              </h4>
            </div>

            <ul
              data-aos-once="true"
              data-aos="fade-up"
              data-aos-easing="ease"
              data-aos-duration="800"
              data-aos-delay="600"
              className="rounded-lg bg-white px-5 py-4 lg:px-6 lg:py-5"
            >
              {EduScheduleList.map(edu => (
                <li
                  className="flex flex-row items-center justify-center gap-5 border-b py-2 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0 lg:gap-8 lg:py-3"
                  key={edu.title}
                >
                  <h6 className="w-[53px] shrink-0 text-sm font-semibold leading-normal text-yellow-450 lg:w-[60px] lg:text-base lg:font-bold">
                    {edu.title}
                  </h6>
                  <p className="flex-1 whitespace-pre-line text-sm text-label-normal lg:whitespace-normal lg:text-base">
                    {edu.content}
                  </p>
                </li>
              ))}
            </ul>
          </div>
        </div>

        <div className="mx-auto w-full max-w-7xl px-4 lg:px-6">
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-3 flex w-full max-w-7xl flex-col rounded-lg bg-white p-4 px-4 lg:mt-6 lg:px-6 lg:py-5"
          >
            <h6 className="mb-2 text-left text-sm font-semibold text-yellow-450 lg:mb-3 lg:text-base">
              참고사항
            </h6>
            <p className="mb-2 w-full border-b pb-2 text-sm text-label-normal lg:text-base">
              국민내일배움카드로 K-Digital Training 과정에 <br className="block lg:hidden" />
              참여할 수 있는 분만 수강 가능합니다.
            </p>
            <p className="w-full text-sm text-label-normal lg:text-base">
              매달 출석률에 따라 훈련장려금이 차등 지급됩니다.
            </p>
          </div>
        </div>
      </section>

      {/* section14_자주묻는질문 */}
      <section className="bg-white pb-[90px] pt-[50px] lg:py-[120px]">
        <div
          data-aos-once="true"
          data-aos="fade-up"
          data-aos-easing="ease"
          data-aos-duration="800"
          data-aos-delay="300"
          className="mx-auto w-full max-w-7xl px-4 lg:px-6"
        >
          <h4 className="mb-4 text-center font-bold text-label-normal lg:mb-6 lg:text-left lg:text-4xl">
            자주 묻는 질문
          </h4>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="300"
            className="mx-auto mb-10 flex max-w-[324px] flex-wrap items-center justify-center gap-1.5 lg:mb-16 lg:max-w-none lg:flex-nowrap lg:justify-start lg:gap-2"
          >
            {bootCampFaqTabList.map(tabItem => {
              const isActive = tabItem.value === faqTab
              return (
                <li
                  className={`${
                    isActive
                      ? 'bg-yellow-450 text-white'
                      : 'border border-normal bg-white text-gray-400'
                  } cursor-pointer rounded-full px-5 py-1.5 text-xs font-bold lg:px-6 lg:py-2 lg:text-sm`}
                  onClick={() => onClickFaqTab(tabItem.value)}
                  key={tabItem.value}
                >
                  {tabItem.label}
                </li>
              )
            })}
          </ul>
          <ul
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mx-auto flex flex-col"
          >
            {faqList.map(faq => (
              <li
                className={`${styles.faqItem} border-b border-[#E5E5E5] py-4 first-of-type:pt-0 last-of-type:border-0 last-of-type:pb-0 lg:py-6`}
                key={faq.question}
              >
                <details className="group overflow-hidden">
                  <summary className="cursor-pointer list-none group-open:pb-1 lg:group-open:pb-2">
                    <div className="flex w-full items-center justify-between gap-4">
                      <div>
                        <p
                          className={`${styles.faq_item_title} text-sm font-semibold text-label-normal lg:text-lg`}
                        >
                          {faq.question}
                        </p>
                      </div>
                      <ChevronDownIcon className="w-4 shrink-0 text-gray-500 group-open:rotate-180 lg:w-6" />
                    </div>
                  </summary>
                  <div className="pl-5 lg:pl-[22px]">
                    <div className="whitespace-pre-wrap text-sm leading-normal text-gray-500 lg:text-base">
                      {faq.answer && (
                        <span className="max-w-full">
                          {faq.answer}
                          {faq.externalUrl1 && (
                            <>
                              {' '}
                              자세한 발급 과정은 아래 링크를 통해 확인 가능합니다.
                              <br />-{' '}
                              <Link href={faq.externalUrl1} target="_blank" className="underline">
                                {' '}
                                {faq.urlName1}
                              </Link>
                              {faq.secondAnswer}
                            </>
                          )}
                          {faq.externalUrl2 && (
                            <>
                              <br />-{' '}
                              <Link href={faq.externalUrl2} target="_blank" className="underline">
                                {' '}
                                {faq.urlName2}
                              </Link>
                            </>
                          )}
                        </span>
                      )}
                      {faq.answerList &&
                        faq.answerList.map(el => (
                          <p key={el} className="text-sm text-gray-500 lg:text-base">
                            {el}
                          </p>
                        ))}
                    </div>
                  </div>
                </details>
              </li>
            ))}
          </ul>
          <div
            data-aos-once="true"
            data-aos="fade-up"
            data-aos-easing="ease"
            data-aos-duration="800"
            data-aos-delay="600"
            className="mt-10 flex flex-col items-center justify-between gap-3 rounded-md bg-[#FFF3EB] p-3 lg:mt-16 lg:flex-row lg:items-center lg:rounded-lg lg:p-10"
          >
            <p className="flex-1 text-center text-sm font-semibold text-label-normal lg:text-left lg:text-lg lg:font-bold">
              더 궁금한 점이 있다면 <br className="block lg:hidden" />
              언제든지 교육 매니저에게 물어보세요!
            </p>
            <div className="flex w-full flex-row gap-1.5 lg:w-auto lg:gap-2.5">
              <Link
                href="https://likelion.channel.io/workflows/724928"
                target="_blank"
                className="flex h-9 flex-1 flex-row items-center justify-center gap-1.5 rounded bg-white px-3 text-sm font-bold text-yellow-450 lg:h-[50px] lg:w-[206px] lg:gap-2 lg:rounded-lg lg:text-lg"
              >
                1:1 문의하기
                <img
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-13th/faq_icon_btn.png"
                  className="h-4 w-4 shrink-0 object-contain lg:h-[18px] lg:w-[18px]"
                  alt="1:1 문의하기"
                />
              </Link>
              <div
                className="flex h-9 w-9 shrink-0 items-center justify-center rounded bg-yellow-450 lg:h-[50px] lg:w-[50px] lg:rounded-lg"
                onClick={() =>
                  copyUrlShare('https://bootcamp.likelion.net/school/kdt-dataanalysis-5th')
                }
              >
                <img
                  src="https://d35ai18pny966l.cloudfront.net/course/kdt/kdt-frontend-13th/faq_icon_share.png"
                  className="h-4 w-4 shrink-0 object-contain lg:h-6 lg:w-6"
                />
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  )
}

export default DataKlass5th
